// =============================
// Imports
// =============================

import { Component } from 'react';
import PropTypes from 'prop-types';
import Head from 'next/head';
import { compose } from 'redux';
import { connect } from 'react-redux';

import { withTranslation } from '../../config/i18n';

import AppShell from '../../components/presentationals/appShell';
import PrivateRoute from '../../components/containers/privateRoute';
import BriefsPage from '../../components/layouts/meta/briefs';
import WithMetaInitData from '../../components/other/withMetaInitData';
import MetaPageFetcher from '../../components/other/metaPageFetcher';

import {
  getMetaBriefs,
  createMetaBrief,
  deleteMetaBriefs,
  modifyMetaBrief,
  uploadMetaBriefFile,
  cancelMetaBriefFileUpload,
  exportMetaBriefTracks,
} from '../../store/actions/MetaActions';

import { getWebsiteTitle } from '../../helpers/misc';

// =============================
// Page
// =============================

export class MetaBriefs extends Component {
  static propTypes = {
    routerProps: PropTypes.shape({
      panel: PropTypes.string,
    }).isRequired,
    i18n: PropTypes.shape({
      language: PropTypes.string,
    }).isRequired,
    t: PropTypes.func.isRequired,
  };

  static async getInitialProps({ query }) {
    return {
      routerProps: query,
      namespacesRequired: ['common', 'pages', 'components', 'errors'],
    };
  }

  render() {
    const { i18n: { language }, t, ...props } = this.props;

    return (
      <PrivateRoute checkMeta>
        <WithMetaInitData>
          <AppShell.Content noHorizontalPadding>
            <Head>
              <title>{getWebsiteTitle(t('pages:meta.briefs.meta_title'))}</title>
            </Head>
            <MetaPageFetcher
              entity="brief"
              child={BriefsPage}
              pathName="/meta/briefs"
              refreshInterval={1500}
              t={t}
              locale={language}
              {...props}
            />
          </AppShell.Content>
        </WithMetaInitData>
      </PrivateRoute>
    );
  }
}

function mapStateToProps({ core, user, meta, sidepanel, player }) {
  return {
    relationsNotifications: user.relationsNotifications.briefs,
    providers: meta.providers,
    columnsPreferences: core.localPreferences.meta.columns.brief,
    userEmail: user.data.email,
    pageFetcherData: meta.briefs,
    sidePanelIsOpened: sidepanel.isOpened,
    playerIsOpened: player.isOpened,
  };
}

export default compose(
  withTranslation(['common', 'pages']),
  connect(
    mapStateToProps,
    {
      fetchFnc: getMetaBriefs,
      createFnc: createMetaBrief,
      deleteFnc: deleteMetaBriefs,
      onChange: modifyMetaBrief,
      onUpload: uploadMetaBriefFile,
      onUploadCancel: cancelMetaBriefFileUpload,
      exportTracksFnc: exportMetaBriefTracks,
    },
    undefined,
    { pure: false },
  ),
)(MetaBriefs);
